export const getUserInitials = (fullName: string): string => {
  const trimmed = fullName.trim();
  if (!trimmed) {
    return '?';
  }

  const nameParts = trimmed.split(/\s+/);
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }

  const firstInitial = nameParts[0].charAt(0).toUpperCase();
  const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
  return `${firstInitial}${lastInitial}`;
};
